/*eslint-disable*/
import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useNavigate } from "react-router-dom";
import GridItem from "components/Grid/GridItem.js";
import { offices,STYLES } from "config";
import moment from "moment";
import {
  Row,
  Col,
  Label,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  FormGroup,
  Input,
  FormText,
  Button,
} from "reactstrap";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

import AddBoxRounded from "@material-ui/icons/AddBoxRounded";
import { FirebaseContext } from "common";

const CreateBranch = () => {
  const { api } = useContext(FirebaseContext);
  const {
    createBranch,
    clearBranchErrors,
    fetchBranchesEnquiries,
    fetchAllBranchListings,
    updateBranch,
    deleteBranch,
  } = api;

  //console.log(api);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const branchManagementReducer = useSelector((state) => state.branchData);
  const usertypes = useSelector((state) => state.usertypes.userstypes);
  const brokers = useSelector((state) => state.brokers.users);
  const usersdata = useSelector((state) => state.usersdata);

  const adminsdata = useSelector((state) => state.usersdata.admins);

  console.log("adminsdata", adminsdata);

  // State for modal visibility and form data
  const [brokerList, setBrokerList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBrokers, setSelectedBrokers] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedBranchToDelete, setSelectedBranchToDelete] = useState(null);

  const [successMessage, setSuccessMessage] = useState("");

  const [error, setError] = useState(null);
  const [officeData, setBranchData] = useState({
    BranchName: "",
    Province: "",
    manager: "",
    address: "",
    contactInfo: "",
    admin: "",

    // share: auth?.info?.profile?.brokerHomeOffice,
  });

  const [isCardView, setIsCardView] = useState(true);
  const toggleModal = () => setIsOpen(!isOpen);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBranchData({ ...officeData, [name]: value });
  };

  const handleBrokerChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedBrokers(selectedValue); // Update selectedBroker
    setBranchData({ ...officeData, manager: selectedValue }); // Sync with officeData.manager
  };

  const handleDeleteClick = (rowData) => {
    setSelectedBranchToDelete(rowData);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (selectedBranchToDelete) {
      try {
        await dispatch(
          deleteBranch({ branchId: selectedBranchToDelete.branchId })
        );
        setIsDeleteModalOpen(false);
        setSelectedBranchToDelete(null); // Clear selection
      } catch (error) {
        console.error("Error deleting branch:", error);
        alert("Failed to delete branch: " + error.message); // Notify user on failure
      }
    }
  };
  //Admin handler
  const handleAdminChange = (e) => {
    const selectedOption = e.target.value;
    setSelectedAdmin(selectedOption);
    setBranchData({ ...officeData, admin: selectedOption }); // Sync with officeData.manager
  };

  // Handle submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(createBranch(officeData));

    if (result.success) {
      alert(result.message);
      toggleModal();
      setBranchData({
        BranchName: "",
        Province: "",
        manager: "",
        address: "",
        contactInfo: "",
        admin: " ",
      });
    }
    if (result.success) {
      alert(result.message);
      toggleModal();
      setBranchData({
        BranchName: "",
        Province: "",
        manager: "",
        address: "",
        contactInfo: "",
        admin: " ",
      });
    }
  };

  //Edit button
  const handleEditClick = (rowData) => {
    setSelectedBranch(rowData);
    setBranchData({
      BranchName: rowData.BranchName,
      Province: rowData.Province,
      manager: rowData.manager,
      address: rowData.address,
      contactInfo: rowData.contactInfo,
      admin: rowData.admin,
    });
    setIsEditModalOpen(true);
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    await dispatch(
      updateBranch({ ...officeData, branchId: selectedBranch.branchId })
    );
    setIsEditModalOpen(false);
  };

  const brokerMap = Array.isArray(brokers)
    ? brokers.reduce((map, broker) => {
        map[broker.id] = `${broker.firstName} ${broker.lastName}`;
        return map;
      }, {})
    : {};

  //!!Extremly important useEffect
  //?? Used to tell if the Enquiry was Created and handle errors from reducers and actions
  useEffect(() => {
    console.log(
      "branchReducer.branches.length",
      branchManagementReducer.branches
    );
    if (branchManagementReducer.completed && branchManagementReducer.success) {
      alert("Branch Created");
    }

    if (
      !branchManagementReducer?.success &&
      branchManagementReducer?.error?.flag
    ) {
      console.log(
        "branchManagementReducer.error",
        branchManagementReducer.error.msg
      );
      alert("Create Branch Failed", branchManagementReducer.error.msg);
      dispatch(clearBranchErrors());
    }
  }, [branchManagementReducer]);

  useEffect(() => {
    let arr = [];
    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        arr.push({
          value: element.id,
          label: `${element.firstName} ${element.lastName}`, // Broker name
        });
      }
      setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
    }
  }, [brokers]);

  const renderDeleteModal = () => (
    <Modal
      isOpen={isDeleteModalOpen}
      toggle={() => setIsDeleteModalOpen(false)}
      centered
    >
      <ModalHeader toggle={() => setIsDeleteModalOpen(false)}>
        Confirm Delete
      </ModalHeader>
      <ModalBody>
        Are you sure you want to delete the branch "
        {selectedBranchToDelete?.BranchName}"?
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={confirmDelete}>
          Yes, Delete
        </Button>
        <Button onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
  const renderEditModal = () => (
    <Modal
      isOpen={isEditModalOpen}
      toggle={() => setIsEditModalOpen(false)}
      centered
    >
      <ModalHeader toggle={() => setIsEditModalOpen(false)}>
        Edit Branch
      </ModalHeader>
      <ModalBody>
        <Card
          style={{
            backgroundColor: STYLES.PRIMARY_APP_CLR,
            width: "95%",
            height: "100%",
          }}
        >
          <CardHeader>
            <CardTitle tag="h4" style={{ color: "white" }}>
              Branch Details
            </CardTitle>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleUpdateSubmit}>
              <FormText>Branch Name:</FormText>
              <Input
                type="text"
                name="BranchName"
                value={officeData.BranchName}
                onChange={(e) =>
                  setBranchData({ ...officeData, BranchName: e.target.value })
                }
                required
                style={{
                  borderWidth: 2,
                  borderColor: STYLES.TERTIARY_APP_CLR,
                  height: 40,
                  backgroundColor: "white",
                  fontSize: 16,
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                  borderRadius: 8,
                  color: "grey",
                  paddingRight: 30,
                }}
              />

              <FormText>Province:</FormText>
              <Input
                type="text"
                name="Province"
                value={officeData.Province}
                onChange={(e) =>
                  setBranchData({ ...officeData, Province: e.target.value })
                }
                required
                style={{
                  borderWidth: 2,
                  borderColor: STYLES.TERTIARY_APP_CLR,
                  height: 40,
                  backgroundColor: "white",
                  fontSize: 16,
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                  borderRadius: 8,
                  color: "grey",
                  paddingRight: 30,
                }}
              />

              <FormText>Manager:</FormText>
              <Input
                type="text"
                name="manager"
                value={officeData.manager}
                onChange={(e) =>
                  setBranchData({ ...officeData, manager: e.target.value })
                }
                required
                style={{
                  borderWidth: 2,
                  borderColor: STYLES.TERTIARY_APP_CLR,
                  height: 40,
                  backgroundColor: "white",
                  fontSize: 16,
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                  borderRadius: 8,
                  color: "grey",
                  paddingRight: 30,
                }}
              />

              <FormText>Address:</FormText>
              <Input
                type="text"
                name="address"
                value={officeData.address}
                onChange={(e) =>
                  setBranchData({ ...officeData, address: e.target.value })
                }
                required
                style={{
                  borderWidth: 2,
                  borderColor: STYLES.TERTIARY_APP_CLR,
                  height: 40,
                  backgroundColor: "white",
                  fontSize: 16,
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                  borderRadius: 8,
                  color: "grey",
                  paddingRight: 30,
                }}
              />

              <FormText>Contact Info:</FormText>
              <Input
                type="text"
                name="contactInfo"
                value={officeData.contactInfo}
                onChange={(e) =>
                  setBranchData({ ...officeData, contactInfo: e.target.value })
                }
                required
                style={{
                  borderWidth: 2,
                  borderColor: STYLES.TERTIARY_APP_CLR,
                  height: 40,
                  backgroundColor: "white",
                  fontSize: 16,
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                  borderRadius: 8,
                  color: "grey",
                  paddingRight: 30,
                }}
              />

              <FormText>Admin:</FormText>
              <Input
                type="text"
                name="admin"
                value={officeData.admin}
                onChange={(e) =>
                  setBranchData({ ...officeData, admin: e.target.value })
                }
                required
                style={{
                  borderWidth: 2,
                  borderColor: STYLES.TERTIARY_APP_CLR,
                  height: 40,
                  backgroundColor: "white",
                  fontSize: 16,
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                  borderRadius: 8,
                  color: "grey",
                  paddingRight: 30,
                }}
              />

              <ModalFooter>
                <Button
                  type="submit"
                  style={{ backgroundColor: STYLES.PRIMARY_APP_CLR, color: "white" }}
                >
                  Update
                </Button>
                <Button
                  onClick={() => setIsEditModalOpen(false)}
                  style={{ backgroundColor: STYLES.TERTIARY_APP_CLR, color: "white" }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
  // Render modal for branch creation
  const renderModal = () => (
    <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered size="lg">
      <ModalHeader toggle={() => setIsOpen(false)}>Create Branch</ModalHeader>
      <ModalBody>
        <Card
          style={{
            backgroundColor: STYLES.PRIMARY_APP_CLR,
            width: "95%",
            height: "100%",
          }}
        >
          <CardHeader>
            <CardTitle tag="h4" style={{ color: "white" }}>
              Branch Details
            </CardTitle>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit}>
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Branch Name:
                </FormText>
                <Input
                  type="text"
                  name="BranchName"
                  value={officeData.BranchName}
                  onChange={handleChange}
                  required
                  style={{
                    borderWidth: 2,
                    borderColor: STYLES.TERTIARY_APP_CLR,
                    height: 40,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                />
              </GridItem>

              {/* Admin Input */}
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Admin:
                </FormText>
                <Input
                  type="text"
                  name="Admin"
                  value={selectedAdmin.admin}
                  onChange={handleAdminChange}
                  required
                  style={{
                    borderWidth: 2,
                    borderColor: STYLES.TERTIARY_APP_CLR,
                    height: 40,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                />
              </GridItem>

              {/* Address Input */}
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Address:
                </FormText>
                <Input
                  type="text"
                  name="address"
                  value={officeData.address}
                  onChange={handleChange}
                  required
                  style={{
                    borderWidth: 2,
                    borderColor: STYLES.TERTIARY_APP_CLR,
                    height: 40,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                />
              </GridItem>

              {/* Contact Information Input */}
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Contact Info:
                </FormText>
                <Input
                  type="text"
                  name="contactInfo"
                  value={officeData.contactInfo}
                  onChange={handleChange}
                  required
                  style={{
                    borderWidth: 2,
                    borderColor: STYLES.TERTIARY_APP_CLR,
                    height: 40,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                />
              </GridItem>

              {/* Province Input */}
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Province:
                </FormText>
                <Input
                  type="text"
                  name="Province"
                  value={officeData.Province}
                  onChange={handleChange}
                  required
                  style={{
                    borderWidth: 2,
                    borderColor: STYLES.TERTIARY_APP_CLR,
                    height: 40,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                />
              </GridItem>

              {/* Dropdown for selecting Managing Broker */}
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Managing Broker:
                </FormText>
                <select
                  style={{
                    width: "100%",
                    height: "40px",
                    padding: "2px",
                    borderWidth: 2,
                    borderColor: STYLES.TERTIARY_APP_CLR,
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  value={selectedBrokers.manager}
                  onChange={handleBrokerChange}
                  required
                >
                  <option value="" disabled>
                    Select a Manager
                  </option>
                  {brokerList.map((broker) => (
                    <option key={broker.value} value={broker.value}>
                      {broker.label}
                    </option>
                  ))}
                </select>
              </GridItem>

              {/* Modal Footer with buttons */}
              <ModalFooter>
                <Button
                  type="submit"
                  style={{ backgroundColor: STYLES.PRIMARY_APP_CLR, color: "white" }}
                >
                  Create Branch
                </Button>
                <Button
                  onClick={() => setIsOpen(false)}
                  style={{ backgroundColor: STYLES.TERTIARY_APP_CLR, color: "white" }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );

  return (
    <>
      <div>
        <Button
          onClick={() => setIsOpen(true)}
          startIcon={<AddBoxRounded />}
          style={{
            backgroundColor: STYLES.TERTIARY_APP_CLR,
            color: "white",
            marginBottom: "1rem",
          }}
        >
          Create Branch
        </Button>

        {/* Render Modal */}
        {renderModal()}

        {successMessage && (
          <div style={{ color: "green", marginTop: "10px" }}>
            {successMessage}
          </div>
        )}
      </div>

      <Row>
        <Card
          style={{
            backgroundColor: STYLES.PRIMARY_APP_CLR,
            width: "100%",
            height: "20%",
          }}
        >
          <CardHeader>
            <CardTitle tag="h4" style={{ color: "white" }}>
              Branch Table
            </CardTitle>
          </CardHeader>
          <CardBody>
            <MaterialTable
              title={"Branches"}
              columns={[
                {
                  title: "Branch Name",
                  field: "BranchName",
                  render: (rowData) => (
                    <Button
                      color="primary"
                      onClick={() => {
                        navigate("/branchInfo", { state: rowData });
                        dispatch(fetchBranchesEnquiries(rowData.BranchName));
                        dispatch(fetchAllBranchListings(rowData.BranchName));
                      }} // Pass branch data
                    >
                      {rowData.BranchName}
                    </Button>
                  ),
                },
                { title: "Admin", field: "admin" },
                {
                  title: "Manager",
                  field: "manager",
                  render: (rowData) =>
                    brokerMap[rowData.manager] || "No Manager",
                },
                {
                  title: "Date Created",
                  field: "createdAt",
                  render: (rowData) => (
                    <span>
                      {moment(rowData.createdAt).format("MMMM Do YYYY")}
                    </span>
                  ),
                },
                { title: "Province", field: "Province" },
                { title: "Contact", field: "contactInfo" },
                { title: "Adddress", field: "address" },

                {
                  title: "Actions",
                  render: (rowData) => (
                    <>
                      <Button
                        color="warning"
                        onClick={() => handleEditClick(rowData)}
                      >
                        Edit
                      </Button>
                      <Button
                        color="danger"
                        onClick={() => handleDeleteClick(rowData)}
                      >
                        Delete
                      </Button>
                    </>
                  ),
                },
              ]}
              data={branchManagementReducer.branches}
              // Use the fetched branches data
              options={{
                sorting: true,
                search: true,
                paging: true,
              }}
            />
          </CardBody>
        </Card>
        {/* Statistics Card */}
        <Col md={4}>
          <Card
            className="card-chart"
            style={{
              minWidth: "275px",
              border: "3px solid",
              borderColor: STYLES.PRIMARY_APP_CLR,
              borderRadius: 30,
            }}
          >
            <CardHeader>
              <CardTitle
                tag="h2"
                style={{
                  fontSize: 30,
                  fontWeight: "1000",
                  margin: "10px 0 0 1px",
                  color: STYLES.TERTIARY_APP_CLR,
                }}
              >
                STATISTICS
              </CardTitle>
            </CardHeader>
            <CardBody>
              {/* Displaying example statistics - replace with actual data as needed */}
              <Row mb="12">
                <Col md="12">
                  <span style={{ fontSize: 18 }}>Total Branches:</span>{" "}
                  {branchManagementReducer.branches.length}
                </Col>
                {/* Add more statistics as needed */}
              </Row>
            </CardBody>
            <CardFooter>
              <Button color="primary" onClick={() => navigate("/branchStats")}>
                Stats
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default CreateBranch;
